import { Link } from "react-router-dom";

const relatedArticles = [
  {
    title: "Hoobuy vs Pandabuy: Qual Escolher em 2026",
    url: "/hoobuy-vs-pandabuy",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20different%20luxury%20running%20sneakers%20facing%20opposite%20directions%20on%20split%20background%20half%20white%20half%20dark%2C%20dramatic%20studio%20lighting%2C%20editorial%20comparison%20concept%2C%20clean%20product%20photography%2C%20no%20text&width=800&height=500&seq=rel-v3-01&orientation=landscape",
  },
  {
    title: "Melhor Agente de Compras da China 2026",
    url: "/melhor-agente-2026",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20shopping%20interface%20next%20to%20luxury%20fashion%20accessories%20on%20white%20desk%2C%20soft%20overhead%20light%2C%20tech%20lifestyle%20editorial%2C%20no%20text&width=800&height=500&seq=rel-v3-02&orientation=landscape",
  },
  {
    title: "Segurança no Hoobuy: Dicas Essenciais",
    url: "/seguranca-hoobuy",
    imageUrl: "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20stainless%20steel%20padlock%20with%20a%20luxury%20leather%20wallet%20underneath%20on%20dark%20wood%2C%20warm%20candlelight%20ambiance%2C%20security%20concept%20photography%2C%20no%20text&width=800&height=500&seq=rel-v3-03&orientation=landscape",
  },
];

export default function RelatedArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            Continue Lendo
          </h2>
          <p className="text-base text-foreground-500">Artigos Relacionados</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {relatedArticles.map((article) => (
            <Link
              key={article.url}
              to={article.url}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              <div className="h-44 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-sm font-bold font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500">
                  Leia mais sobre este tópico
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}